import { DatePipe, NgOptimizedImage } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import {
  RdsButtonComponent,
  RdsProgressBarComponent,
} from '@rds/angular-components';

import { MaintenanceService } from '../maintenance.service';

@Component({
  selector: 'bsh-maintenance-page',
  templateUrl: './maintenance-page.component.html',
  styleUrls: ['./maintenance-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    DatePipe,
    NgOptimizedImage,
    RdsButtonComponent,
    RdsProgressBarComponent,
  ],
})
export class MaintenancePageComponent {
  readonly #maintenanceService = inject(MaintenanceService);

  protected readonly info = this.#maintenanceService.info;
  protected readonly isChecking = signal(false);

  protected async retry() {
    this.isChecking.set(true);
    try {
      await this.#maintenanceService.refresh(true);
    } finally {
      this.isChecking.set(false);
    }
  }
}
